import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchPredictionFeedback } from "#modules/feedback/infra/fetchPredictionFeedback.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const predictionFeedbackQuery = (id: string | undefined) => ({
  queryKey: queryKeys.predictionFeedback.detail(id),
  queryFn: () => fetchPredictionFeedback(id),
  staleTime: STALE_TIME,
  enabled: !!id,
});
